// file t.b.v. het uitlezen van de url parameters uit de url string waarmee we extra knoppen kunnen laten zien in de UI

export function getUrlParams() {
  const params = {};
  const queryString = window.location.search.substring(1);
  const pairs = queryString.split('&');
  
  for (let i = 0; i < pairs.length; i++) {
    if (!pairs[i]) continue;
    
    const pair = pairs[i].split('=');
    params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  
  return params;
}

export function getUrlParam(name, defaultValue = null) {
  const params = getUrlParams();
  return params[name] !== undefined ? params[name] : defaultValue;
}
